export function parsePeselDate(pesel: string): [number, number, number] {
  const yearPart = parseInt(pesel.slice(0, 2));
  const monthPart = parseInt(pesel.slice(2, 4));
  const dayPart = parseInt(pesel.slice(4, 6));

  const year = 1800 + 100 * (Math.ceil(monthPart / 20) % 5) + yearPart;
  const month = monthPart % 20;

  return [year, month, dayPart];
}

function _validateMonth(pesel: string): boolean {
  const monthStr = pesel.slice(2, 4);

  return !(monthStr === '00' || (+monthStr[0] % 2 && +monthStr[1] > 2));
}

function _validateDay(pesel: string): boolean {
  const _isLeapYear = (fullYear: number) => !(fullYear % 4) && (fullYear % 100 || !(fullYear % 400));

  const [year, month, day] = parsePeselDate(pesel);
  const longMonths = [1, 3, 5, 7, 8, 10, 12];

  if (day < 1) return false;
  if (month === 2)
    if (_isLeapYear(year)) return day <= 29;
    else return day <= 28;
  if (longMonths.indexOf(month) !== -1) return day <= 31;
  else return day <= 30;
}

function validateCharacters(pesel: string): boolean {
  if (typeof pesel !== 'string') return false;

  return /^[0-9]{11}$/.test(pesel.trim());
}

function validateBirthdate(pesel: string): boolean {
  return _validateMonth(pesel) && _validateDay(pesel);
}

function validateControl(pesel: string): boolean {
  const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3, 1];
  const sum = weights.reduce((acc, weight, index) => acc + weight * +pesel[index], 0);
  return sum % 10 === 0;
}

export const isPeselValid = (pesel: string): boolean =>
  validateCharacters(pesel) && validateBirthdate(pesel) && validateControl(pesel);
